<template>
  <v-btn icon @click="$emit('click')" :height="size" :disabled="disabled" :width="size">
    <v-fade-transition>
      <v-icon
        :size="size"
        v-if="!recording"
        v-text="'$vuetify.icons.appMicrophone'"
        :style="`width: ${size}px !important;`"
      />
      <v-icon
        :size="size"
        v-else
        :style="`width: ${size}px !important;`"
        v-text="'$vuetify.icons.appMicrophoneOn'"
      />
    </v-fade-transition>
  </v-btn>
</template>
<script>
export default {
  props: {
    recording: Boolean,
    size: {
      type: String,
      default: "176",
    },
    disabled: Boolean,
  },
};
</script>
